import { render, staticRenderFns } from "./flowPayFali.vue?vue&type=template&id=bfeb050e&scoped=true&"
import script from "./flowPayFali.vue?vue&type=script&lang=js&"
export * from "./flowPayFali.vue?vue&type=script&lang=js&"
import style0 from "./flowPayFali.vue?vue&type=style&index=0&id=bfeb050e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfeb050e",
  null
  
)

export default component.exports